import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from "@angular/core";
import {AiAgentModel} from "../../../models/ai-agent.model";

require('./ai-agents-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-ai-agents-table-row',
  templateUrl: './ai-agents-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiAgentsTableRowComponent {

  @Input() aiAgent: AiAgentModel;
  @Input() allowEdit: boolean;
  @Input() allowDelete: boolean;

  @Output() editAiAgentEvent = new EventEmitter<AiAgentModel>();
  @Output() deleteAiAgentEvent = new EventEmitter<AiAgentModel>();

  constructor() {
  }

}
